import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

const NavExpansionSetterContext = createContext<(slot: ReactNode | null) => void>(() => {});
const NavExpansionValueContext = createContext<ReactNode | null>(null);

export function NavExpansionProvider({ children }: { children: ReactNode }) {
  const [expansionSlot, setExpansionSlotState] = useState<ReactNode | null>(null);
  const setExpansionSlot = useCallback((slot: ReactNode | null) => {
    setExpansionSlotState(slot);
  }, []);

  return (
    <NavExpansionSetterContext.Provider value={setExpansionSlot}>
      <NavExpansionValueContext.Provider value={expansionSlot}>
        {children}
      </NavExpansionValueContext.Provider>
    </NavExpansionSetterContext.Provider>
  );
}

export function useSetExpansionSlot() {
  return useContext(NavExpansionSetterContext);
}

export function useNavExpansionSlot() {
  return useContext(NavExpansionValueContext);
}

export function useNavExpansion() {
  return {
    expansionSlot: useNavExpansionSlot(),
    setExpansionSlot: useSetExpansionSlot(),
  };
}
